import { Container, Stack, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LoadingAnimation, PageHeader } from "../molecules";
import { apiUrls } from "../../services/apiUrls";
import { FilterCard, InsightList } from "../organisms";
import axios from "axios";

export const Insight = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoriesData, setCategoriesData] = useState();
  const [insightsData, setInsightsData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [categoryPages, setCategoryPages] = useState({});
  const [categoryTotalPages, setCategoryTotalPages] = useState({});
  const pageSize = 4; // Number of items per page

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      const categoriesResponse = await axios.get(apiUrls.insight.getCategories);
      const categoriesList = categoriesResponse?.data?.data?.map((data) => ({
        id: data?.id,
        ...data?.attributes,
      }));
      setCategoriesData(categoriesList);

      // Initialize pagination state for each category
      const initialPages = {};
      const initialTotalPages = {};
      categoriesList?.forEach((category) => {
        initialPages[category.title] = 1;
        initialTotalPages[category.title] = 1;
      });
      setCategoryPages(initialPages);
      setCategoryTotalPages(initialTotalPages);

      // Fetch insights for each category
      const insightsPromises = categoriesList?.map((category) =>
        axios.get(
          apiUrls.insight.getInsights
            .replace("${page}", 1)
            .replace("${pageSize}", pageSize) +
            `&filters[categories][title][$eq]=${encodeURIComponent(
              category.title
            )}`
        )
      );

      const insightsResponses = await Promise.all(insightsPromises);
      const allInsights = insightsResponses.flatMap((response) =>
        response?.data?.data?.map((data) => ({
          id: data?.id,
          ...data?.attributes,
        }))
      );

      // Update total pages for each category
      const newTotalPages = { ...initialTotalPages };
      insightsResponses.forEach((response, index) => {
        const categoryTitle = categoriesList[index].title;
        newTotalPages[categoryTitle] =
          response?.data?.meta?.pagination?.pageCount || 1;
      });
      setCategoryTotalPages(newTotalPages);

      setInsightsData(allInsights);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handlePageChange = (categoryTitle, page) => {
    const fetchCategoryInsights = async () => {
      setIsLoading(true);
      const response = await axios.get(
        apiUrls.insight.getInsights
          .replace("${page}", page)
          .replace("${pageSize}", pageSize) +
          `&filters[categories][title][$eq]=${encodeURIComponent(
            categoryTitle
          )}`
      );

      const newInsights = response?.data?.data?.map((data) => ({
        id: data?.id,
        ...data?.attributes,
      }));

      // Update insights for this category
      setInsightsData((prevInsights) => {
        const otherCategoryInsights = prevInsights.filter(
          (insight) =>
            insight.categories.data[0].attributes.title !== categoryTitle
        );
        return [...otherCategoryInsights, ...newInsights];
      });

      setCategoryPages((prev) => ({
        ...prev,
        [categoryTitle]: page,
      }));

      setIsLoading(false);
    };

    fetchCategoryInsights();
  };

  const filteredInsightList = insightsData?.filter((insight) => {
    if (searchText?.length > 0) {
      return insight?.title?.toLowerCase().includes(searchText?.toLowerCase());
    } else {
      return insightsData;
    }
  });

  return (
    <>
      <PageHeader title="Research" />

      {isLoading ? (
        <LoadingAnimation />
      ) : (
        <Container maxWidth="lg">
          <Stack
            spacing="32px"
            direction={{ xs: "column", sm: "row" }}
            style={{ margin: !isMobile ? "64px 0" : "32px 0" }}
          >
            {/* FILTER CARD */}
            <FilterCard
              items={categoriesData?.map((item) => item?.title)}
              selectedItem={selectedCategory}
              setSelectedItem={setSelectedCategory}
              setSearchText={setSearchText}
              searchText={searchText}
              style={{ flex: "none" }}
            />

            {/* INSIGHT LIST */}
            <InsightList
              categories={categoriesData}
              selectedCategory={selectedCategory}
              insights={filteredInsightList}
              categoryPages={categoryPages}
              categoryTotalPages={categoryTotalPages}
              onPageChange={handlePageChange}
            />
          </Stack>
        </Container>
      )}
    </>
  );
};
